import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useDismissNotificaiton, useGetNotificationByType } from '@/queries/notification.queries';
import { NotificationType } from '@/repositories/notification.repository';
import { useToast } from '@cmpsr/components';

export default function useNotificationsController() {
  const { data: notificationData, refetch } = useGetNotificationByType(NotificationType.ScreeningFollowUp);
  const dismissNotificationMutation = useDismissNotificaiton(notificationData?.id ?? '');
  const toast = useToast();

  function dismissNotification() {
    dismissNotificationMutation
      .mutateAsync()
      .then(() => {
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          description: 'The notification was marked as completed.',
          status: 'success',
        });
        refetch();
      })
      .catch((error) => {
        console.error(error);
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          title: `Error ${error.response?.data?.statusCode ?? ''}`,
          description: error.response?.data?.message ?? error.message,
          status: 'error',
        });
      });
  }

  return { notification: notificationData, dismissNotification };
}
